import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {SortableContainer} from "react-sortable-hoc";
import SortableChapterItem from './SortableChapterItem';

class SortableChapterList extends Component {
    render(){


        if(this.props.chapters) {
            return (
                <div

                    className="panel-body no-padding"
                    id={"panel_chapter_" + this.props.number}
                >
                    {this.props.chapters.map((items, index) => {

                        return (
                            <SortableChapterItem
                                key={`item-${index}`}
                                number={this.props.number}
                                numberIndex={index}
                                index={index}
                                item={items}
                                deleteChapterConfirmation={(item) => this.props.deleteChapterConfirmation(item)}
                                editChapter={this.props.editChapter}
                                reorderChapterParts={this.props.reorderChapterParts}
                                user={this.props.user}
                                updateChapterStatus={this.props.updateChapterStatus}
                                updateChapterPartStatus={this.props.updateChapterPartStatus}
                                 history={this.props.history}
                                 addTest={this.props.addTest}

                            />
                        )
                    }

                    )}
                </div>
            )
        }else{
            return <div>...</div>
        }
    }
}


SortableChapterList.propTypes = {
    chapters: PropTypes.array.isRequired,
    number: PropTypes.number,
    showModalDelete: PropTypes.func.isRequired,
    setSelectedEditChapterPartId: PropTypes.func.isRequired
};

export default SortableContainer(SortableChapterList);


// WEBPACK FOOTER //
// ./src/components/AdminPanel/SortableChapterList.js